module.exports = __webpack_public_path__ + "img/W-C92.1049152a.jpg";